var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.25rem",
    height: "1.25rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rzi42vmjva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 553",
    style: {
      stroke: "#707070"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61682"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11274",
    style: {
      clipPath: "url(#rzi42vmjva)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61586"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9416",
    d: "M-4334.55-4369.912a9.309 9.309 0 0 1 9.265 9.833 9.124 9.124 0 0 1-1.455 4.449c-.3.463-.713.6-1.09.36s-.432-.655-.132-1.135a7.8 7.8 0 0 0-4.579-11.764 7.818 7.818 0 0 0-9.746 6.638 7.81 7.81 0 0 0 8.186 8.716 7.777 7.777 0 0 0 3.468-1.025 1.231 1.231 0 0 1 .571-.18.647.647 0 0 1 .644.536.687.687 0 0 1-.344.8 8.8 8.8 0 0 1-2.771 1.1 9.248 9.248 0 0 1-11.079-7.19 9.261 9.261 0 0 1 7.519-10.974c.511-.074 1.029-.107 1.543-.164z",
    transform: "translate(4344.54 4370.638)",
    style: {
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9417",
    d: "M-4311.5-4336.045h-2.4c-.522 0-.853-.287-.851-.727s.329-.719.856-.72h2.4v-.831c0-.566-.009-1.133 0-1.7a.716.716 0 0 1 .705-.726.712.712 0 0 1 .736.728c.013.828 0 1.657 0 2.527h2.15c.133 0 .265-.006.4 0a.722.722 0 0 1 .708.721.71.71 0 0 1-.708.72c-.722.015-1.446 0-2.17.006h-.377v.757c0 .578.007 1.156 0 1.734a.723.723 0 0 1-.7.762.721.721 0 0 1-.739-.765c-.017-.814-.01-1.629-.01-2.486z",
    transform: "translate(4320.783 4346.792)",
    style: {
      strokeWidth: ".5px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuestion);
export default __webpack_public_path__ + "static/media/AddQuestion.caf6d1d073686eb4467256792a999001.svg";
export { ForwardRef as ReactComponent };